// extracted by mini-css-extract-plugin
export var actions = "_r3-4";
export var item = "_r3-1";
export var price = "_r3-3";
export var quantity = "_r3-2";
export var table = "_r3-0";